import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import userReducer from './userReducer/userSlice'
import loaderReducer from "./loaderReducer/loaderSlice";
import errorReducer from './errorReducer/errorSlice'
export const store = configureStore({
    reducer:{
        user:userReducer,
        loader:loaderReducer,
        error:errorReducer
    },
    middleware:[logger]
})